import React from 'react'
import ScrollToBottom from 'react-scroll-to-bottom'
import moment from 'moment'
import { Spin } from 'antd'
import { formatters } from '@utils/intl/dateTimeFormatters'

export const Logs = ({ logs, isLoading, isSupply }) => {
  return (
    <div className={`console-container ml-3 mt-2 ${isSupply ? 'supply' : ''}`}>
      <div
        className='console-window'
        style={isLoading ? { display: 'flex', justifyContent: 'center', alignItems: 'center' } : {}}
      >
        {isLoading ? <Spin size='large' /> : <JobDetails log={logs} />}
      </div>
    </div>
  )
}

const JobDetails = ({ log }) => {
  if (!log) return <>To begin logging, kick off a run in model management</>
  return (
    <ScrollToBottom className='console-scroll'>
      {log.map((v, i) => (
        <div key={i}>
          <span>
            <span className='console-time'>{formatters.DATE_TIME(moment.utc(v.time))}:</span> {v.message}
          </span>
          <br />
        </div>
      ))}
    </ScrollToBottom>
  )
}
